var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenshare = function SvgScreenshare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#screenshare_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#screenshare_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.986 20.21H4.016a2.753 2.753 0 0 1-2.752-2.752V6.75a2.753 2.753 0 0 1 2.751-2.752h2.239c.412 0 .75.337.75.75 0 .412-.338.75-.75.75H4.015c-.689 0-1.251.562-1.251 1.252v10.709c0 .689.562 1.251 1.251 1.251h15.976c.689 0 1.251-.562 1.251-1.252v-3.445c0-.413.337-.75.75-.75.412 0 .75.337.75.75v3.446a2.76 2.76 0 0 1-2.756 2.751Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39 16.213a.745.745 0 0 1-.75-.736v-1.5c0-5.376 4.372-9.75 9.75-9.75h.247V.974a.746.746 0 0 1 1.29-.516l6.501 6.75c.281.291.281.75 0 1.041L16.927 15a.748.748 0 0 1-1.29-.516v-3.248h-1.185a8.205 8.205 0 0 0-7.379 4.561.792.792 0 0 1-.684.417Zm9-10.49c-4.2 0-7.679 3.154-8.19 7.218a9.69 9.69 0 0 1 7.247-3.22h1.936c.412 0 .75.338.75.75v2.142l4.716-4.889-4.712-4.889v2.142c0 .413-.337.75-.75.75h-.998v-.004Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.986 20.21H4.016a2.753 2.753 0 0 1-2.752-2.752V6.75a2.753 2.753 0 0 1 2.751-2.752h2.239c.412 0 .75.337.75.75 0 .412-.338.75-.75.75H4.015c-.689 0-1.251.562-1.251 1.252v10.709c0 .689.562 1.251 1.251 1.251h15.976c.689 0 1.251-.562 1.251-1.252v-3.445c0-.413.337-.75.75-.75.412 0 .75.337.75.75v3.446a2.76 2.76 0 0 1-2.756 2.751Z",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39 16.213a.745.745 0 0 1-.75-.736v-1.5c0-5.376 4.372-9.75 9.75-9.75h.247V.974a.746.746 0 0 1 1.29-.516l6.501 6.75c.281.291.281.75 0 1.041L16.927 15a.748.748 0 0 1-1.29-.516v-3.248h-1.185a8.205 8.205 0 0 0-7.379 4.561.792.792 0 0 1-.684.417Zm9-10.49c-4.2 0-7.679 3.154-8.19 7.218a9.69 9.69 0 0 1 7.247-3.22h1.936c.412 0 .75.338.75.75v2.142l4.716-4.889-4.712-4.889v2.142c0 .413-.337.75-.75.75h-.998v-.004Z",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 21.475,
    width: 24,
    height: 1.895,
    rx: 0.947,
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "screenshare_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "screenshare_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgScreenshare;